import { createSelector } from "reselect";
import { sectionsSelector } from "../../../sections_selector";

export const evaluationListPURSSectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.evaluationListPURS;
  }
);
